import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  getPurchaseById,
  RESET_PURCHASE,
  selectPurchase,
  selectupdatePurchaseSuccess,
  updatePurchase,
} from "../../redux/features/Purchase/PurchaseSlice";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { FaArrowLeft } from "react-icons/fa";

const AddPurchase = () => {
  const purchase = useSelector(selectPurchase);
  const [updatedPurchase, setUpdatedPurchase] = useState(null);
  const [errors, setErrors] = useState({});
  const { id } = useParams();
  const dispatch = useDispatch();
  const isSuccess = useSelector(selectupdatePurchaseSuccess);
  const navigate = useNavigate();

  const handleReceivingChange = (type, id, value) => {
    setUpdatedPurchase((prev) => {
      if (!prev) return prev;

      const updatedData = { ...prev };
      let newErrors = { ...errors };

      if (type === "ingredient") {
        updatedData.ingredients = updatedData.ingredients.map((ingredient) => {
          if (ingredient.ingredientId === id) {
            if (Number(value) > Number(ingredient.ingredientRemaining)) {
              newErrors[id] = "Cannot exceed remaining quantity!";
            } else {
              delete newErrors[id];
            }
            return { ...ingredient, ingredientReceiving: Number(value) };
          }
          return ingredient;
        });
      } else if (type === "item") {
        updatedData.items = updatedData.items.map((item) => {
          if (item.itemId === id) {
            if (Number(value) > Number(item.itemRemaining)) {
              newErrors[id] = "Cannot exceed remaining quantity!";
            } else {
              delete newErrors[id];
            }
            return { ...item, itemReceiving: Number(value) };
          }
          return item;
        });
      }

      setErrors(newErrors);
      return updatedData;
    });
  };

  const handleSubmit = async (id) => {
    // console.log("before", updatedPurchase);
    const purchaseData = {
      items: updatedPurchase.items
        .filter((item) => item.itemStatus === "open" && item.itemReceiving > 0)
        .map(
          ({
            itemId,
            itemName,
            itemQuantity,
            itemReceiving,
            conversionRate,
          }) => ({
            itemId,
            itemName,
            itemQuantity,
            itemReceiving,
            conversionRate,
          })
        ),

      ingredients: updatedPurchase.ingredients
        .filter(
          (ingredient) =>
            ingredient.ingredientStatus === "open" &&
            ingredient.ingredientReceiving > 0
        )
        .map(
          ({
            ingredientId,
            ingredientName,
            ingredientQuantity,
            ingredientReceiving,
            conversionRate,
          }) => ({
            ingredientId,
            ingredientName,
            ingredientQuantity,
            ingredientReceiving,
            conversionRate,
          })
        ),
    };

    if (
      (!purchaseData.ingredients || purchaseData.ingredients.length < 1) &&
      (!purchaseData.items || purchaseData.items.length < 1)
    ) {
      return toast.error("Minimun 1 regredient or item is requried.");
    }

    await dispatch(updatePurchase({ id, purchaseData }));
  };

  useEffect(() => {
    if (isSuccess) {
      navigate("/purchases");
      dispatch(RESET_PURCHASE());
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    if (purchase) {
      const newPurchase = {
        ...purchase,
        ingredients:
          Array.isArray(purchase.ingredients) && purchase.ingredients.length > 0
            ? purchase.ingredients.map((ingredient) => ({
                ...ingredient,
                ingredientReceiving: ingredient.ingredientRemaining,
              }))
            : [],

        items:
          Array.isArray(purchase.items) && purchase.items.length > 0
            ? purchase.items.map((item) => ({
                ...item,
                itemReceiving: item.itemRemaining,
              }))
            : [],
      };

      setUpdatedPurchase(newPurchase);
    }
  }, [purchase]);

  useEffect(() => {
    dispatch(getPurchaseById(id));
  }, [dispatch, id]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1] overflow-hidden">
      <Navbar page="Add Purchase" />
      <div className="flex flex-col flex-1 overflow-x-hidden overflow-y-auto scrollbar-hide relative ">
        <NavLink
          to={"/purchases"}
          className="flex justify-start items-center gap-2 sticky top-0 px-3 bg-transparent py-2 text-[#0D868C]"
        >
          <FaArrowLeft />
          Back
        </NavLink>
        <div className=" bg-white lg:w-[80%] w-[95%] h-max mx-auto my-16 p-8 rounded-xl">
          {updatedPurchase ? (
            <div className=" flex flex-col gap-4">
              <div className="flex items-center gap-4">
                <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                  Purchase No: {updatedPurchase.purchaseNo}
                </span>
                <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                  Date:{" "}
                  {dayjs(updatedPurchase.createdAt).format(
                    "D/MM/YY (dddd) h:mm A "
                  )}
                </span>
              </div>
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[20%] text-left">
                      Name
                    </th>
                    <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[15%] text-left">
                      Quantity
                    </th>
                    <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[15%] text-left">
                      Receiving Qty
                    </th>
                    <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[15%] text-left">
                      Remaining Qty
                    </th>
                    <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[10%] text-left">
                      Status
                    </th>
                    <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[25%] text-left">
                      Add Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {updatedPurchase?.ingredients?.length > 0 && (
                    <>
                      <tr>
                        <td
                          colspan="6"
                          className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                        >
                          ingredient
                        </td>
                      </tr>
                      {updatedPurchase?.ingredients?.map((ingredient) => (
                        <tr key={ingredient.ingredientId}>
                          <td className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize">
                            {ingredient?.ingredientName}
                          </td>
                          <td
                            title={`${
                              ingredient.ingredientQuantity *
                              ingredient?.conversionRate
                            } ${ingredient.unitOfMeasure}`}
                            className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                          >
                            {ingredient?.ingredientQuantity}{" "}
                            {ingredient?.purchaseUnit}
                          </td>
                          <td
                            title={`${
                              ingredient.ingredientReceived *
                              ingredient?.conversionRate
                            } ${ingredient.unitOfMeasure}`}
                            className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                          >
                            {ingredient?.ingredientReceived}{" "}
                            {ingredient?.purchaseUnit}
                          </td>
                          <td
                            title={`${
                              ingredient.ingredientRemaining *
                              ingredient?.conversionRate
                            } ${ingredient.unitOfMeasure}`}
                            className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                          >
                            {ingredient?.ingredientRemaining}{" "}
                            {ingredient?.purchaseUnit}
                          </td>
                          <td className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize">
                            {ingredient?.ingredientStatus}
                          </td>
                          <td className="border border-gray-300 text-[.8rem]  capitalize">
                            <div>
                              <input
                                value={ingredient?.ingredientReceiving}
                                type="number"
                                min={0}
                                step={0.01}
                                onWheel={(e) => e.target.blur()}
                                placeholder="Add receiving quantity"
                                className={`outline-none w-full py-2 px-1 ${
                                  errors[ingredient.ingredientId]
                                    ? "border-red-500"
                                    : ""
                                }`}
                                onChange={(e) =>
                                  handleReceivingChange(
                                    "ingredient",
                                    ingredient.ingredientId,
                                    e.target.value
                                  )
                                }
                                disabled={
                                  ingredient?.ingredientStatus?.toLowerCase() ===
                                  "close"
                                }
                              />
                              {errors[ingredient.ingredientId] && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors[ingredient.ingredientId]}
                                </p>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </>
                  )}

                  {updatedPurchase?.items?.length > 0 && (
                    <>
                      <tr>
                        <td
                          colspan="6"
                          className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                        >
                          item
                        </td>
                      </tr>
                      {updatedPurchase?.items?.map((item) => (
                        <tr key={item.itemId}>
                          <td className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize">
                            {item?.itemName}
                          </td>
                          <td
                            title={`${
                              item.ingredientQuantity * item?.conversionRate
                            } ${item.unitOfMeasure}`}
                            className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                          >
                            {item?.itemQuantity} {item?.purchaseUnit}
                          </td>
                          <td
                            title={`${
                              item.itemReceived * item?.conversionRate
                            } ${item.unitOfMeasure}`}
                            className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                          >
                            {item?.itemReceived} {item?.purchaseUnit}
                          </td>
                          <td
                            title={`${
                              item.itemRemaining * item?.conversionRate
                            } ${item.unitOfMeasure}`}
                            className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                          >
                            {item?.itemRemaining} {item?.purchaseUnit}
                          </td>
                          <td className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize">
                            {item?.itemStatus}
                          </td>
                          <td className="border border-gray-300 text-[.8rem]  capitalize">
                            <div>
                              <input
                                value={item?.itemReceiving}
                                type="number"
                                min={0}
                                step={0.01}
                                onWheel={(e) => e.target.blur()}
                                placeholder="Add receiving quantity"
                                className={`outline-none w-full py-2 px-1 ${
                                  errors[item.itemId] ? "border-red-500" : ""
                                }`}
                                onChange={(e) =>
                                  handleReceivingChange(
                                    "item",
                                    item.itemId,
                                    e.target.value
                                  )
                                }
                                disabled={
                                  item?.itemStatus?.toLowerCase() === "close"
                                }
                              />
                              {errors[item.itemId] && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors[item.itemId]}
                                </p>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </table>
              <div className="flex justify-end items-center">
                <button
                  disabled={Object.keys(errors).length > 0}
                  onClick={() => handleSubmit(updatedPurchase._id)}
                  className=" bg-[#0D868C] text-white font-semibold px-3 py-1.5 rounded-lg"
                >
                  save
                </button>
              </div>
            </div>
          ) : (
            <div>No Purchase Found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddPurchase;
